/* Social: la piattaforma è dedotta dall'host dell'URL (il tenant salva solo l'URL),
   così la redazione incolla il link e l'icona giusta compare da sola. Sistema
   condiviso tra SiteFooter (server) e MobileNav (client): componente puro, senza
   hook né API browser, quindi sicuro in entrambi i contesti. */
export type SocialKind = 'facebook' | 'instagram' | 'x' | 'linkedin' | 'youtube' | 'tiktok' | 'telegram' | 'link'

export function socialKind(url: string): SocialKind {
  const h = url.toLowerCase()
  if (h.includes('facebook.') || h.includes('//fb.')) return 'facebook'
  if (h.includes('instagram.')) return 'instagram'
  if (h.includes('linkedin.')) return 'linkedin'
  if (h.includes('youtube.') || h.includes('youtu.be')) return 'youtube'
  if (h.includes('tiktok.')) return 'tiktok'
  if (h.includes('t.me/') || h.includes('telegram.')) return 'telegram'
  if (h.includes('twitter.') || h.includes('//x.com') || h.includes('.x.com')) return 'x'
  return 'link'
}

export const SOCIAL_LABEL: Record<SocialKind, string> = {
  facebook: 'Facebook',
  instagram: 'Instagram',
  x: 'X',
  linkedin: 'LinkedIn',
  youtube: 'YouTube',
  tiktok: 'TikTok',
  telegram: 'Telegram',
  link: 'Sito web',
}

export function SocialIcon({ kind }: { kind: SocialKind }) {
  const p = { width: 18, height: 18, viewBox: '0 0 24 24', 'aria-hidden': true as const }
  switch (kind) {
    case 'facebook':
      return (
        <svg {...p} fill="currentColor">
          <path d="M22 12a10 10 0 1 0-11.56 9.88v-6.99H7.9V12h2.54V9.8c0-2.5 1.49-3.89 3.77-3.89 1.1 0 2.24.2 2.24.2v2.46h-1.26c-1.24 0-1.63.77-1.63 1.56V12h2.78l-.45 2.89h-2.33v6.99A10 10 0 0 0 22 12z" />
        </svg>
      )
    case 'instagram':
      return (
        <svg {...p} fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="3" y="3" width="18" height="18" rx="5" />
          <circle cx="12" cy="12" r="4" />
          <circle cx="17.5" cy="6.5" r="1.2" fill="currentColor" stroke="none" />
        </svg>
      )
    case 'x':
      return (
        <svg {...p} fill="currentColor">
          <path d="M18.24 2.25h3.31l-7.23 8.26 8.5 11.24h-6.65l-5.22-6.82-5.96 6.82H1.68l7.73-8.84L1.25 2.25h6.82l4.71 6.23 5.46-6.23zm-1.16 17.52h1.83L7.08 4.13H5.12l11.96 15.64z" />
        </svg>
      )
    case 'linkedin':
      return (
        <svg {...p} fill="currentColor">
          <path d="M20.45 20.45h-3.56v-5.57c0-1.33-.03-3.04-1.85-3.04-1.86 0-2.14 1.45-2.14 2.94v5.67H9.35V9h3.41v1.56h.05c.48-.9 1.64-1.85 3.37-1.85 3.6 0 4.27 2.37 4.27 5.45v6.29zM5.34 7.43a2.06 2.06 0 1 1 0-4.13 2.06 2.06 0 0 1 0 4.13zM7.12 20.45H3.56V9h3.56v11.45zM22.22 0H1.77C.79 0 0 .77 0 1.73v20.54C0 23.23.79 24 1.77 24h20.45c.98 0 1.78-.77 1.78-1.73V1.73C24 .77 23.2 0 22.22 0z" />
        </svg>
      )
    case 'youtube':
      return (
        <svg {...p} fill="currentColor">
          <path d="M23.5 6.2a3.02 3.02 0 0 0-2.12-2.14C19.5 3.55 12 3.55 12 3.55s-7.5 0-9.38.51A3.02 3.02 0 0 0 .5 6.2 31.5 31.5 0 0 0 0 12a31.5 31.5 0 0 0 .5 5.8 3.02 3.02 0 0 0 2.12 2.14c1.88.51 9.38.51 9.38.51s7.5 0 9.38-.51a3.02 3.02 0 0 0 2.12-2.14A31.5 31.5 0 0 0 24 12a31.5 31.5 0 0 0-.5-5.8zM9.55 15.57V8.43L15.82 12l-6.27 3.57z" />
        </svg>
      )
    case 'tiktok':
      return (
        <svg {...p} fill="currentColor">
          <path d="M16.5 1.5h-3.2v13.6a2.74 2.74 0 1 1-2.74-2.74c.27 0 .53.04.78.11V9.2a6.13 6.13 0 1 0 5.16 6.05V8.3a7.6 7.6 0 0 0 4.45 1.43V6.46a4.45 4.45 0 0 1-4.45-4.45V1.5z" />
        </svg>
      )
    case 'telegram':
      return (
        <svg {...p} fill="currentColor">
          <path d="M23.91 3.79 20.3 20.84c-.25 1.2-.98 1.5-1.99.93l-5.5-4.06-2.65 2.56c-.3.29-.54.54-1.1.54l.39-5.56L19.7 6.1c.44-.39-.1-.6-.68-.22L6.28 13.5.67 11.75c-1.22-.38-1.24-1.22.26-1.8L22.18 1.9c1.02-.37 1.91.24 1.73 1.89z" />
        </svg>
      )
    default:
      return (
        <svg {...p} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
          <circle cx="12" cy="12" r="9" />
          <path d="M3 12h18M12 3a14 14 0 0 1 0 18 14 14 0 0 1 0-18z" />
        </svg>
      )
  }
}
